import React, { useContext, useEffect, useState } from 'react';
import SummaryApi from '../common';
import Context from '../context';
import displayINRCurrency from '../helpers/displayCurrency';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import { useSelector } from 'react-redux';
import ROLE from '../common/role';
import defaultImage from '../assest/DAWACO_Icon.png'; 
import MinimumBar from '../components/MinimumBar';

const SalesmanPaymentPage = () => {
    const [data, setData] = useState([]);
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [addLoading, setAddLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false); 
    const context = useContext(Context);
    const navigate = useNavigate();
    const user = useSelector(state => state?.user?.user);
    const [length,setLength] = useState('0')
    var d = [];
    const [pharmacies, setPharmacies] = useState([]);
    const [selectedPharmacy, setSelectedPharmacy] = useState("");
    const [isAddingNewPharmacy, setIsAddingNewPharmacy] = useState(false);
    const [newPharmacy, setNewPharmacy] = useState({
         name: "", 
         email: "", 
         password:"DAWACO12345DAWACO67890",
         shippingAddress:"",
         profilePic: "",
         role: "GENERAL",
         mobileNumber: "",
         type: "Default",
         isVerified: false,
         emailIsVerified: true,
         governorate:"",
         region: "",
         pharmacistOrPharmacy:"pharmacy",
         purchasingManager:""
         
        });
        const [barMinimum, setBarMinimum] = useState('');
        const [purchasingManager, setPurchasingManager] = useState("");
        const [isManagerChanged, setIsManagerChanged] = useState(false);
        const [bonusQuantities, setBonusQuantities] = useState({});
        const [clientNotes, setClientNotes] = useState("");

        const handleSelectChange = (e) => {
          
             setIsManagerChanged(false)

            if (e.target.value === "addNew") {
              setIsAddingNewPharmacy(true);
              setPurchasingManager("");
              setSelectedPharmacy("");
            } else if (e.target.value === "") {
                setSelectedPharmacy("");
                setPurchasingManager("");
                setIsAddingNewPharmacy(false);
            }
            else {
              const SelectedPharmacy = pharmacies.find(pharmacy => pharmacy._id === e.target.value);
              setSelectedPharmacy(SelectedPharmacy);
              setPurchasingManager(SelectedPharmacy?.purchasingManager);
              setIsAddingNewPharmacy(false);
            }
          };
    
      const handleNewPharmacyChange = (e) => {
        const { name, value } = e.target;
      
        if (name === 'governorate') {
          setNewPharmacy((prev) => ({ ...prev, [name]: value, region: '' }));
        } else {
          setNewPharmacy((prev) => ({ ...prev, [name]: value }));
        }
      };
      
    

      const addNewPharmacy = async() => {
        
        if (/[^0-9]/.test(newPharmacy.mobileNumber)) {
          toast.error('يجب أن يحتوى رقم الهاتف الجوال على أرقام فقط');
          return;
        }
      
        setAddLoading(true); 
      
        try {
          const response = await fetch(SummaryApi.addUser.url, {
            method: SummaryApi.addUser.method,
            credentials: 'include',
            headers: {
              "content-type": "application/json"
            },
            body: JSON.stringify({
              data: newPharmacy,
              email: newPharmacy.email,
              password: newPharmacy.password,
            }),
          });
      
          const responseData = await response.json();
      
          if (responseData.success) {
            setLoading(false);
            toast.success("تم إضافة الصيدلية الجديدة بنجاح");
            setSelectedPharmacy("")
            setIsAddingNewPharmacy(false);
            salesmanFetchUsers();
            setNewPharmacy({
                name: "", 
                email: "", 
                password:"DAWACO12345DAWACO67890",
                shippingAddress:"",
                profilePic: "",
                role: "GENERAL",
                mobileNumber: "",
                type: "Default",
                isVerified: false,
                emailIsVerified: true,
                governorate:"",
                region: "",
                pharmacistOrPharmacy:"pharmacy",
                purchasingManager:""
                
               });
               
            
          } else {
            toast.error(responseData?.message);
          }
        } catch (error) {
          toast.error('حدث خطأ أثناء إضافة الصيدلية الجديدة');
        } finally {
            setAddLoading(false);
        }
      };




    useEffect(() => {
        setLoading(true);
        const loadingTimeout = setTimeout(() => {
          
          setLoading(false);
          navigate("/");
        }, 10000); 
    
        if (user) {
          if (user?.role !== ROLE.SALESMAN) {
            
            navigate("/");
            setLoading(false);
          } 
          else {

            setLoading(false);
            clearTimeout(loadingTimeout)
            handleLoading()
            
          }
        } 
    
        // Clear the timeout when the component unmounts or the effect is rerun
        return () => clearTimeout(loadingTimeout);
      }, [user, navigate]);

      const processBonusQuantities = async () => {
        const initialBonusQuantities = {};

            d.forEach((product) => {

              var bonus = 0

              if(product?.productDetails?.toBonus>0 &&product?.productDetails?.bonusQuantity>0 ){
                bonus = Math.max(Math.min((Math.floor(product?.quantity / product?.productDetails?.toBonus)) * product?.productDetails?.bonusQuantity,
                product?.productDetails?.quantity-product?.quantity),0); 
              }

                initialBonusQuantities[product._id] = bonus;
            });

            setBonusQuantities(initialBonusQuantities);

    };


      const fetchBarMinimum= async () => {
        try {
            const response = await fetch(SummaryApi.getBarMinimum.url, {
                method: SummaryApi.getBarMinimum.method,
                credentials: 'include',
                headers: {
                    "Content-Type": 'application/json'
                }
            });
            const responseData = await response.json();
            setBarMinimum(responseData?.data);
        } catch (error) {
        }
    };

    const fetchData = async () => {
        try {
            const response = await fetch(SummaryApi.addToCartProductView.url, {
                method: SummaryApi.addToCartProductView.method,
                credentials: 'include',
                headers: {
                    'content-type': 'application/json',
                },
            });
            const responseData = await response.json();
            if (responseData.success) {
                setData(responseData.data);
                d = responseData.data;
                setLength(d.length)
            } else {
                toast.error('حدث خطأ');
            }
        } catch (error) {
            toast.error('حدث خطأ');
        }
    };
    const salesmanFetchUsers = async () => {
        try {
          const response = await fetch(SummaryApi.salesManGetUsers.url, {
            method: SummaryApi.salesManGetUsers.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
           
          });
      
          const result = await response.json();
      
          if (result.success) {
            if (result.data.length === 0) {
              setPharmacies([]);
            } else {
              setPharmacies(result.data);
            }
          } else {
            toast.error(result.message || 'حدث خطأ');
          }
        } catch (error) {
          toast.error('حدث خطأ');
        }
      };

    const handleLoading = async () => {
        await fetchData();
        await processBonusQuantities();
        await fetchUserDetails();
        await fetchBarMinimum();
        await salesmanFetchUsers();
        
    };

    const fetchUserDetails = async () => {
        try {
            const response = await fetch(SummaryApi.current_user.url, {
                method: SummaryApi.current_user.method,
                credentials: 'include',
                headers: {
                    'content-type': 'application/json',
                },
            });
            const responseData = await response.json();
            if (responseData.success) {
                setUserDetails(responseData.data);
            } else {
                toast.error('حدث خطأ');
            }
        } catch (error) {
            toast.error('حدث خطأ');
        }
    };



    const totalPrice = data.reduce((preve, curr) => {
        const price = curr?.productDetails?.sellingPrice > 0 ? curr?.productDetails?.sellingPrice : curr?.productDetails?.price;
        return preve + (curr?.quantity * price);
    }, 0);

    const handlePayment = async () => {
        try {
            const response = await fetch(SummaryApi.salesmanPaymentController.url, {
                method: SummaryApi.salesmanPaymentController.method,
                credentials: 'include',
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    cartItems: d,
                    paymentMethod: 'cash',
                    type : d[0].type,
                    note : "",
                    selectedPharmacy: selectedPharmacy,
                    purchasingManager: purchasingManager,
                    bonusQuantities : bonusQuantities,
                })
            });

            const responseData = await response.json();

            if (response.ok && responseData.success) {
                // Payment successful
            } else {
                toast.error("فشل الدفع. يرجى المحاولة مرة أخرى");
            }
        } catch (error) {
            toast.error("حدث خطأ أثناء عملية الدفع. يرجى المحاولة مرة أخرى.");
        }
    };

    const handleConfirmPayment = async () => {
        try {
            await fetchData();

            let isAvailable = true;
            let i = 0;

            while (isAvailable && i < d.length) {
                const product = d[i];
                if (product?.quantity > product?.productDetails?.quantity) {
                    isAvailable = false;
                }
                i++;
            }

            const targetProduct = d[i - 1];

            if (isAvailable) {
                try {
                    
                    const orderDetails = {
                        items: d.map((product) => ({
                            productName: product?.productDetails?.productName,
                            quantity: product?.quantity,
                            totalPrice: product?.quantity * (product?.productDetails?.sellingPrice > 0 ? product?.productDetails?.sellingPrice : product?.productDetails?.price),
                            bonus:Math.max(Math.min(bonusQuantities[product._id],(product?.productDetails?.quantity-product?.quantity)),0)

                        })),
                        totalPrice: totalPrice,
                        shippingAddress: selectedPharmacy?.shippingAddress,
                        date: new Date().toLocaleDateString(),
                        purchasingManager : purchasingManager
                    };

                    const response = await fetch(SummaryApi.userOrderMail.url, {
                        method: SummaryApi.userOrderMail.method,
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            userId: selectedPharmacy?._id,
                            orderDetails: orderDetails,
                        }),
                    });

                    const responseData = await response.json();

                    if(selectedPharmacy?.pharmacistOrPharmacy==="pharmacy"){

                       await fetch(SummaryApi.updateUserDebt.url, {
                        method: SummaryApi.updateUserDebt.method,
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            userId: selectedPharmacy?._id,
                            addedDebt: totalPrice,
                            type : d[0].type,
                        }),
                    });

                }
                        await fetch(SummaryApi.updateProductsQuantity.url, {
                        method: SummaryApi.updateProductsQuantity.method,
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            userId: userDetails?._id,
                            type : d[0].type,
                            isSalesManBonus:true,
                            bonusQuantities:bonusQuantities
                        }),
                    });

                    if (responseData.success) {
                        await handlePayment();
                        const clearCartResponse = await fetch(SummaryApi.clearCartProduct.url, {
                            method: 'POST',
                            credentials: 'include',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });

                        const clearCartResponseData = await clearCartResponse.json();

                        if (clearCartResponseData.success) {
                            toast.success('تم تقديم الطلب بنجاح');
                            context.fetchUserAddToCart(); // Update cart product count in context
                            navigate('/'); // Navigate to home page
                        } else {
                            toast.error('فشل في إفراغ العربة');
                        }
                    } else {
                        toast.error(responseData.message || 'فشل في تقديم الطلب');
                    }
                } catch (error) {
                    toast.error(' حدث خطأ. يرجى المحاولة مرة أخرى');
                }
            } else {
                toast.error(`يوجد فقط ${targetProduct.productDetails.quantity} منتجات متوفرة في المخزن من "${targetProduct.productDetails.productName}" و أنت تحاول طلب ${targetProduct.quantity} منتجات.`);
            }
        } catch (error) {
            toast.error('حدث خطأ. يرجى المحاولة مرة أخرى');
        } finally {
            setButtonLoading(false); 
        }
    };

    const handleConfirmPaymentAndPayment = async () => {
        setButtonLoading(true); 
        if(isManagerChanged){
          handleManagerChanged();
        }
        await handleConfirmPayment();
        
    };

    const handleManagerChanged =  () => {
      try {
        
         fetch(SummaryApi.editManager.url, {
          method: SummaryApi.editManager.method,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userId: selectedPharmacy?._id,
            purchasingManager:purchasingManager
          }),
        });
      } catch (error) {
      } 
    };

    const handleQuantityChange =(id, newQuantity) => {

      setBonusQuantities((prevQuantities) => ({
          ...prevQuantities,
          [id]: newQuantity,
      }));
  };

    if (loading) {
        return (
          <div className="flex justify-center items-center h-screen">
            <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
          </div>
        );
      }

    return (
        <div className="container mx-auto">
             {barMinimum?.at(0)?.seq > totalPrice && (
                <MinimumBar />
            )}

            <div className="flex flex-col lg:flex-row gap-10 lg:justify-between p-4">
                {/* Left Section: Product Summary */}
                <div className="w-full max-w-xl">
                    <h2 className="text-2xl font-bold mb-4">ملخص الطلب</h2>
                    {loading ? (
                        new Array(4).fill(null).map((_, index) => (
                            <div key={index} className="w-full bg-slate-200 h-40 my-2 border border-slate-300 animate-pulse rounded"></div>
                        ))
                    ) : (
                        data.map((product) => (
                            <div key={product?._id} className="w-full bg-white h-40 my-2 border border-slate-300 rounded grid grid-cols-[128px,1fr]">
                                <div className="w-32 h-40 bg-slate-200">
                                    <img
                                        src={product?.productDetails?.productImage[0] || defaultImage}
                                        className="w-full h-full object-scale-down mix-blend-multiply"
                                        alt="product"
                                    />
                                </div>
                                <div className="px-4 py-2 text-right">
                                    <h3 className="text-lg">{product?.productDetails?.productName}</h3>
                                    <p className="text-sm"> {product?.quantity} : الكمية</p>
                                    <input
                                        type='number'
                                        id={`${product?._id}`}
                                        value={bonusQuantities[product?._id] || 0}
                                        onChange={(e) => {
                                          const newQuantity = Math.max(0, Math.min(e.target.value, product?.productDetails?.quantity - product?.quantity));
                                          handleQuantityChange(product?._id, newQuantity);
                                      }}
                                        className="text-sm border border-slate-300 p-0 text-left"
                                        min={0}
                                        max={product?.productDetails?.quantity - product?.quantity}
                                    />
                                    <label htmlFor={`bonus-${product?._id}`} className="text-sm">
                                        : البونص 
                                    </label>
                                    
                                    <p className="text-sm">
                                         {displayINRCurrency(product?.productDetails?.sellingPrice > 0 ? product?.productDetails?.sellingPrice : product?.productDetails?.price)} : سعر المنتج  
                                    </p>
                                    <p className="font-bold">
                                        {displayINRCurrency(product?.quantity * (product?.productDetails?.sellingPrice > 0 ? product?.productDetails?.sellingPrice : product?.productDetails?.price))} : الإجمالى 
                                    </p>

                                </div>
                            </div>
                        ))
                    )}
                    {!loading && (
                        <div className="mt-4 text-right">
                            <h3 className="text-xl font-bold"> {displayINRCurrency(totalPrice)} : السعر الإجمالى</h3>
                        </div>
                    )}
                </div>

                {/* Right Section: Payment Option */}
                <div className="mt-5 lg:mt-0 w-full max-w-sm">
                    {loading ? (
                        <div className="h-36 bg-slate-200 border border-slate-300 animate-pulse"></div>
                    ) : (
                        <div className="bg-white p-4 border shadow-md text-right">
                            <h2 className="text-2xl font-bold mb-4">خيارات الدفع</h2>
                            <div className="text-right ">

                                 <label htmlFor="cash" className="ml-2 ">الدفع نقدا  </label>
                                <input type="radio" id="cash" name="payment" value="cash" checked readOnly />
                                
                            </div>
                            <div>
      <h2 className="text-2xl font-bold mb-4">اختر الصيدلية</h2>
      <div className="text-right">
        <select id="pharmacy" className="border p-2 rounded" value={selectedPharmacy?._id || ""} onChange={handleSelectChange}>
        <option value="" disabled>اختر الصيدلية</option>
          {pharmacies?.map((pharmacy, index) => (
            <option key={index} value={pharmacy?._id}>{pharmacy?.name}</option>
          ))}
          <option value="addNew">أضف صيدلية جديدة</option>
        </select>

        {isAddingNewPharmacy && (
          <div className="mt-4">
            <h3 className="text-xl font-bold mb-2">إضافة صيدلية جديدة</h3>
            <div className='grid'>
            <label>: اسم الصيدلية</label>
            <input
              type="text"
              name="name"
              placeholder="ادخل اسم الصيدلية"
              className="border p-2 rounded mb-2 w-full text-right"
              value={newPharmacy.name}
              onChange={handleNewPharmacyChange}
              required
            />
            </div>

            <div className='grid'>
            <label>: اسم مدير المشتريات</label>
            <input
              type="text"
              name="purchasingManager"
              placeholder="ادخل اسم مدير المشتريات"
              className="border p-2 rounded mb-2 w-full text-right"
              value={newPharmacy.purchasingManager}
              onChange={handleNewPharmacyChange}
              required
            />
            </div>

            <div className='grid'>
            <label> : البريد الإلكترونى</label>
            <input
              type="text"
              name="email"
              placeholder="ادخل البريد الإلكترونى"
              className="border p-2 rounded mb-2 w-full text-right"
              value={newPharmacy.email}
              onChange={handleNewPharmacyChange}
              required
            />
            </div>
            
            <div className='grid'>
            <label>: رقم الهاتف</label>
            <input
              type="text"
              name="mobileNumber"
              placeholder="ادخل رقم الهاتف"
              className="border p-2 rounded mb-2 w-full text-right"
              value={newPharmacy.mobileNumber}
              onChange={handleNewPharmacyChange}
              required
            />
            </div>

            
             <div className='grid'>
            <label>: المدينة</label>
              <select
                name='governorate'
                value={newPharmacy.governorate}
                onChange={handleNewPharmacyChange}
                required
                className='bg-slate-100 p-2 w-full outline-none text-right'
              >
                <option value='' disabled>اختر المدينة</option>
                <option value='طرابلس'>طرابلس</option>
                <option value='بني غازي'>بني غازي</option>
                <option value='مصراتة'>مصراتة</option>
                <option value='الزاوية'>الزاوية</option>
                <option value='زليتن'>زليتن</option>
                <option value='الخمس'>الخمس</option>
                <option value='ترهونة'>ترهونة</option>
                <option value='قربولي'>قربولي</option>
                <option value='الجنوب'>الجنوب</option>
                <option value='منطقة اخري'>منطقة اخري</option>
              </select>
              </div>

              {newPharmacy.governorate === 'طرابلس' && (
              <div className='grid'>
                <label>: المنطقة</label>
                <select
                  name='region'
                  value={newPharmacy.region}
                  onChange={handleNewPharmacyChange}
                  className='bg-slate-100 p-2 w-full outline-none text-right'
                >
                  <option value='' disabled>اختر المنطقة</option>
                  <option value='وسط المدينة'>وسط المدينة</option>
                  <option value='حي الاندلس'>حي الاندلس</option>
                  <option value='قرقارش'>قرقارش</option>
                  <option value='جنزور'>جنزور</option>
                  <option value='غوط الشغال'>غوط الشغال</option>
                  <option value='سوق الجمعة'>سوق الجمعة</option>
                  <option value='تاجوراء'>تاجوراء</option>
                  <option value='قصر بن غشير'>قصر بن غشير</option>
                  <option value='سبيعة'> سبيعة </option>
                  <option value='عين زارة'>عين زارة</option>
                  <option value='الهضبة'>الهضبة</option>
                  <option value='ابوسليم'>ابوسليم</option>
                  <option value='الفرناج'>الفرناج</option>
                </select>
              </div>
            )}

            <div className='grid'>
            <label>: العنوان</label>
            <input
              type="text"
              name="shippingAddress"
              placeholder="ادخل عنوان الصيدلية"
              className="border p-2 rounded mb-2 w-full text-right"
              value={newPharmacy.shippingAddress}
              onChange={handleNewPharmacyChange}
              required
            />
            </div>
            <button
              onClick={addNewPharmacy}
              className={`bg-blue-500 text-white px-4 py-2 rounded ${newPharmacy.name === "" ||newPharmacy.email === ""  || newPharmacy.mobileNumber === "" || newPharmacy.shippingAddress === "" ||newPharmacy.governorate === "" || (newPharmacy.governorate === "طرابلس" && newPharmacy.region === "" ) || addLoading || length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={newPharmacy.name === "" ||newPharmacy.email === ""  || newPharmacy.mobileNumber === "" || newPharmacy.shippingAddress === ""||newPharmacy.governorate === "" || (newPharmacy.governorate === "طرابلس" && newPharmacy.region === "" ) || addLoading || length === 0  } 
            >
             {addLoading ? <AiOutlineLoading3Quarters className="animate-spin" /> : 'إضافة '}
            </button>
          </div>
        )}
      </div>
    </div>
    {selectedPharmacy && (
              <div>
                <div className="text-right">
                  <h3 className="font-semibold">: مدير المشتريات <span className='text-red-500 font-bold mr-1'>*</span></h3>
                </div>
                <input
                  type="text"
                  name="purchasingManager"
                  value={purchasingManager}
                  onChange={(e) => {
                    setPurchasingManager(e.target.value)
                    setIsManagerChanged(true);
                  }}
                  className="border rounded p-1 w-full bg-gray-50 text-sm text-right"
                />
                 <div className="text-right">
                <h3 className="font-semibold">: ملحوظات</h3>
                </div>
                <textarea
                name="clientNotes"
                value={clientNotes}
                onChange={(e) => setClientNotes(e.target.value)}
                className="border rounded p-2 w-full bg-gray-50 text-sm text-right h-24"
                />
              </div>
    )}
                            <button
    className={`mt-4 py-2 px-4 bg-green-500 hover:bg-green-600 text-white rounded ${ barMinimum?.at(0)?.seq > totalPrice || selectedPharmacy === "" || buttonLoading || length === 0 || purchasingManager === "" ? 'opacity-50 cursor-not-allowed' : ''}`}
    onClick={handleConfirmPaymentAndPayment}
    disabled={barMinimum?.at(0)?.seq > totalPrice || selectedPharmacy === "" || buttonLoading || length === 0 || purchasingManager === ""} 
>
    {buttonLoading ? <AiOutlineLoading3Quarters className="animate-spin" /> : 'تنفيذ الطلب'}
</button>

                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SalesmanPaymentPage;
